<template>
  <el-dialog
    :title="editId?$t('widgets_basic_atlas_catalog_components_one_img_428'):$t('widgets_basic_atlas_catalog_index_424')"
    :visible.sync="showtag"
    custom-class="el-popup-parent-imgPop--dialog"
    class="basic_addAtlas"
    width="600"
    v-dialogDrag
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closed"
    @before-close="closeModule"
    v-loading="get_loading"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      :label-width="$store.state.app.web_language_wm == 'en' ? 'auto' : '100px'"
      class="demo-ruleForm el-form-self-check"
      size="mini"
    >
      <el-form-item :label="$t('components_basic_addatlas_index_2068')" prop="album_name">
        <el-input class="nameLine" v-model="ruleForm.album_name"></el-input>
      </el-form-item>
      <staticTips :marginLeft="$store.state.app.web_language_wm == 'en' ? 135 : 100" :marginTop="-14" :typeName="'album.title'"></staticTips>
      <el-form-item :label="$t('components_basic_addatlas_index_2069')" prop="type_name">
        <div class="fifter_tree">
          <div class="open_layer my_layer" v-show="!fifterTree" @click="showTree"></div>
          <div class="close_layer my_layer" v-show="fifterTree" @click="fifterTree = false"></div>
          <div class="fifter_down">
            <!-- 隐藏了一个失去焦点函数 @blur="hiddenTree" -->
            <el-input
              v-model="ruleForm.type_name"
              class="typeLine"
              :readonly='true'
              :clearable="true"
              :placeholder="$t('components_basic_addatlas_index_2070')"
              @focus="showTree"
              @clear="cleanFifter"
            >
              <i v-show="!fifterTree" slot="suffix" class="el-input__icon el-icon-arrow-down" />
              <i v-show="fifterTree" slot="suffix" class="el-input__icon el-icon-arrow-up" />
            </el-input>
          </div>
          <div class="btn_man">
            <el-button size="small" @click="popShow = true">{{$t('widgets_basic_article_classification_edit_320')}}</el-button>
          </div>
          <transition name="slide-fade">
            <el-scrollbar v-show="fifterTree" class="scroll_tree">
              <div v-show="fifterTree" class="fifter_up org_tree org_tree_fifter">
                <el-tree
                  ref="tree2"
                  :data="tree_data"
                  :props="defaultProps"
                  :filter-node-method="filterNode"
                  :expand-on-click-node="false"
                  :default-expand-all="true"
                  class="filter-tree"
                  @node-click="choseOrg"
                />
              </div>
            </el-scrollbar>
          </transition>
        </div>
      </el-form-item>
      <staticTips :marginLeft="$store.state.app.web_language_wm == 'en' ? 135 : 100" :marginTop="-14" :typeName="'album.type_name'"></staticTips>
      <el-form-item :label="$t('components_basic_addatlas_index_2071')" prop="picList">
        <div class="avatar-uploader-part" v-if="ruleForm.picList.length < 15" @click="showpop">
          <i class="el-icon-circle-plus avatar-uploader-icon"></i>
          <p>{{$t('components_basic_addarticle_message_2055')}}</p>
        </div>
        <div v-for="(item, index) in ruleForm.picList" :key="index" class="avatar-uploader-part imgPart">
          <a class="close-avatar-uploader el-icon-circle-close" @click="closeavatar(index)"></a>
          <img v-if="item" :src="item.img_path" class="avatar" @click="changemainpic(index)" />
          <i class="edit img_viewer_edit" @click.stop="img_edit_show(index)"></i>
        </div>
      </el-form-item>
      <staticTips :marginLeft="$store.state.app.web_language_wm == 'en' ? 135 : 100" :marginTop="-14" :typeName="'album.img'"></staticTips>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitForm('ruleForm')" type="primary" :loading="isloading" :disabled="!is_change">{{$t('view_public_topbar_15')}}</el-button>
      <el-button :loading="isloading" @click="closeModule">{{$t('view_public_topbar_14')}}</el-button>
    </div>
    <atlas_edit_img
      v-if="img_edit_isShow"
      :imgs="ruleForm.picList"
      :img_index="img_index"
      @closed="img_edit_close"
      @img_edit_sure="img_edit_sure"
    ></atlas_edit_img>
    <basic_management :typeTag="5" :showTag.sync="popShow" v-if="popShow" @changeType='getNewTypes'></basic_management>
  </el-dialog>
</template>

<script>
import i18n from '../../language/index'

import {
  saveAtlasList,
  editAtlasList,
  gettypeList
} from "@/api/app.js";
import { create_one_img } from "@/base/base";
import atlas_edit_img from "@/components/atlas_edit_img";
import {lockScroll} from '@/base/base'
export default {
  name: "basic_addAtlas",
  data() {
    return {
      changeType: false,
      popShow: false,
      articleWords: i18n.t('components_basic_addarticle_index_2010'),
      get_loading: false,
      isloading: false,
      total: 0,
      type: 5,
      showtag: true,
      proParams: {
        title: i18n.t('components_basic_addatlas_index_2072'),
        type: "add", // 类型： 新增（add）或编辑(edit)
        twebId: 0, // 网站ID
        pid: "0", // 分类类型pid
        id: "0", // 分类类型ID
        objectType: "atlas", //  新增或编辑对象的类型 pro 分类类型
        typevalue: 5
      },
      ruleForm: {
        album_name: "",
        type: "",
        //分类名称
        category_name: "",
        type_name: "",
        category_id: "",
        picList: [],
      },
      dataForm: {
        typeName: "",
        fatherName: "",
        pid: 0
      },
      fifterTree: false,
      defaultProps: {
        children: "children",
        label: "name"
      },
      addTree: [],
      rules: {
        album_name: [
          {
            required: true,
            message: i18n.t('components_basic_addatlas_index_2073'),
            trigger: "blur"
          },
          {
            min: 2,
            max: 60,
            message: i18n.t('components_basic_addatlas_index_2074'),
            trigger: "blur"
          },
          { pattern: /\S+/, message: i18n.t('components_basic_addarticle_message_2020') },
        ],
        type_name: [
          {
            required: true,
            message: i18n.t('components_basic_addatlas_index_2070'),
            trigger: "change"
          }
        ],
        picList: [
          // 图册 图册封面不能为空
          {
            required: true,
            message: i18n.t('components_basic_addatlas_index_2075')
          }
        ],
      },
      tree_data: [],
      img_edit_isShow: false,
      img_index: 0,
      is_change:false
    };
  },
  watch: {
    ruleForm: {
      handler: function (val, oldVal) {
        this.is_change = true;
      },
      deep: true
    },
    'ruleForm.picList': {
      handler: function (val, oldVal) {
        this.$refs['ruleForm'].validate(valid => {})
        this.is_change = true;
      },
      deep: true
    }
  },
  props: {
    editId: {
      type: Number,
      default: 0
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  components: {
    atlas_edit_img
  },
  methods: {
    closeModule() {
      if (this.is_change) {
        this.$confirm(i18n.t('view_dialog_index_170'), i18n.t('view_public_topbar_23'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          center: true,
          // customClass: "del_dialog",
          appendToBody: true
        }).then(() => {
            this.$emit("close")
            this.$nextTick(()=> {
              lockScroll(false)
            })
        }).catch(() => {})
      } else {
        this.$emit("close")
        this.$nextTick(()=> {
          lockScroll(false)
        })
      }
    },
    getNewTypes () {
      this.changeType = true;
      this.getTypes();
    },
    closed() {
      this.showtag = true;
      this.closeModule()
      // this.$emit("close");
    },
    img_edit_close() {
      this.img_edit_isShow = false;
    },
    img_edit_sure(list) {
      this.ruleForm.picList = list;
    },
    closeavatar(index) {
      let data = this.ruleForm.picList;
      data.splice(index, 1);

      this.ruleForm.picList = data;
    },
    changemainpic(index) {
      let imglist = this.ruleForm.picList;
      let newlist = [];
      newlist.push(this.ruleForm.picList[index]);
      imglist.splice(index, 1);
      this.ruleForm.picList = newlist.concat(imglist);
    },
    showpop() {
      const that = this;
      let limit = 15 - this.ruleForm.picList.length
      this.$store.commit("image_upload/set_fileType", 1);
      this.$store.commit("image_upload/set_showTag", true);
      this.$store.commit("image_upload/set_fileLimit", limit);
      this.$store.state.image_upload.imgFile = e => {
        this.ruleForm.picList = this.templet.filterArray(this.ruleForm.picList,e.map(item => {
          return create_one_img(item.filePath,item.fileName);
        }),'img_path');
        that.$store.state.image_upload.imgFile = null;
      };
    },
    set_level(data) {
      if (data instanceof Array) {
        for (let i = 0; i < data.length; i++) {
          data[i].level = 1;
          this.set_level(data[i]);
        }
      } else if (
        data.children &&
        data.children instanceof Array &&
        data.children.length > 0
      ) {
        for (let i = 0; i < data.children.length; i++) {
          data.children[i].level = data.level + 1;
          this.set_level(data.children[i]);
        }
      }
    },
    getTypes() {
      // 获取产品类型ID
      this.loading3 = true;
      gettypeList({
        type: this.type
      })
        .then(res => {
          this.loading3 = false;
          if (res.code === 200 && res.data && res.data.list instanceof Array) {
            this.set_level(res.data.list);
            console.log(res.data.list);
            this.tree_data = res.data.list;
            let addtree = [];
            addtree = res.data.list.map(item => {
              return item;
            });
            this.total = res.data.total;
            this.addTree = addtree;
            if (this.changeType) {
              this.$emit('changeType');
            }
          } else {
            this.tree_data = [];
          }
        })
        .catch(err => {
          this.loading3 = false;
          this.tree_data = [];
        })
        .finally(() => {
          this.loading3 = false;
        });
    },
    showTree() {
      this.fifterTree = true;
      this.$refs.tree2.filter("false");
    },
    cleanFifter() {
      //this.is_clean = true
    },
    hiddenTree() {
      this.fifterTree = false;
    },
    choseOrg(val) {
      this.ruleForm.type_name = val.name;
      this.ruleForm.category_id = val.id;
      this.ruleForm.category_name = val.name;
      this.fifterTree = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      // return data.hide.indexOf(value) !== -1
      return true;
    },
    openDatatype() {
      this.dialogVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.isloading = true;
          let sendParam = {};
          if (this.editId) {
            sendParam.id = this.editId;
          }
          sendParam.album_name = this.ruleForm.album_name;
          sendParam.category_id = this.ruleForm.category_id;
          //过滤一下提交的数据，把没intro的，自动打上
          sendParam.lists = this.templet.atlas_imgs_filter(this.ruleForm.picList);
          //console.log(JSON.stringify(sendParam))
          saveAtlasList(sendParam)
            .then(res => {
              if (res.code == 200) {
                this.$message.success(i18n.t('components_basic_addatlas_index_2076'));
                this.isloading = false;
                this.$emit("close");
                this.$emit("submit_sure", res.data);
                this.$nextTick(()=> {
                    lockScroll(false)
                })
              } else {
                this.isloading = false;
                this.$message.error(res.message);
              }
            })
            .finally(() => {
              this.isloading = false;
              this.loading = false;
            });
        } else {
          this.isloading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    editAtlasList() {
      if (!this.editId) return;
      this.get_loading = true;
      let data = {
        id: this.editId
      };
      editAtlasList(data)
        .then(res => {
          if (res.code == 200) {
            this.loading = false;
            this.ruleForm.album_name = res.data.album_name;
            this.ruleForm.category_id = res.data.category_id;
            this.ruleForm.category_name = res.data.relation_category.name;

            // this.imageUrl = []
            this.ruleForm.type_name = this.ruleForm.category_name;
            if (res.data && res.data.lists && res.data.lists instanceof Array) {
              this.ruleForm.picList = this.templet.atlas_imgs_filter(res.data.lists);
              console.log(this.ruleForm.picList);
            }

            this.ruleForm.type_id = this.ruleForm.category_id;
          }
        })
        .finally(() => {
          this.get_loading = false;
          this.is_change = false;
        });
    },
    img_edit_show(i) {
      this.img_index = i;
      this.img_edit_isShow = true;
    }
  },
  mounted() {
    lockScroll(true)
    this.getTypes();
    if (this.editId) {
      this.editAtlasList();
    }
  }
};
</script>

<style scoped lang="scss">
.nameLine1 {
  width: 200px;
}

.typeLine {
  width: 200px;
}
.avatar-uploader-part:hover .edit {
  display: block;
}

.basic_addAtlas {
  /deep/ .el-dialog__header {
    border: 1px solid #e3e2e8;
  }
  /deep/ .el-dialog__footer {
    .dialog-footer {
      text-align: center;
      .el-button {
        margin: 8px 18px;
        padding: 0 28px;
        height: 34px;
      }
    }
  }
  /deep/ .el-dialog {
    width: 600px;
  }
}
.fifter_down {
  width: 60%;
  display: inline-block;
}
.btn_man {
  display: inline-block;
  float: right;
}
.fifter_tree .my_layer {
  width: 60% !important;
}
.scroll_tree {
  height: 100px;
  overflow-y: auto;
  position: absolute;
  overflow-x: hidden;
  left: 0;
  border: 1px solid #eee;
  width: 44%;
  background: #fff;
  z-index: 10;
  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
    margin-right: 0 !important;
  }
}
.el-form-self-check {
  .el-form-item.is-error {
    margin-bottom:35px !important;
  }
  .el-form-item.zi_customer {
    margin-bottom:24px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic_addAtlas/index.vue